class FsAccordion extends HTMLElement {
  constructor() {
    super()

    this.allowMultiple = this.dataset.allowMultiple === 'true'
    this.elsItems = Array.from(this.querySelectorAll('.fs-accordion__item'))
    this.currentIndex = null
    this.mm = gsap.matchMedia()

    this.addEventListeners()
  }

  addEventListeners() {
    this.elsItems.forEach((elItem, index) => {
      const elSummary = elItem.querySelector('summary')
      elSummary.addEventListener('click', (e) => {
        this.mm.add('(prefers-reduced-motion: no-preference)', () => {
          e.preventDefault()
          this.toggleItem(index)
        })
      })
    })
  }

  async toggleItem(index) {
    const elItem = this.elsItems[index]
    const isOpen = elItem.querySelector('details').open

    if (!this.allowMultiple && this.currentIndex !== null && this.currentIndex !== index) {
      const elCurrentItem = this.elsItems[this.currentIndex]
      this.closeItem(elCurrentItem)
    }

    if (isOpen) {
      await this.closeItem(elItem)
      this.currentIndex = null
    } else {
      this.currentIndex = index
      this.openItem(elItem)
    }
  }

  async closeItem(elItem) {
    const elDetails = elItem.querySelector('details')
    const elContent = elItem.querySelector('.fs-accordion__content')
    const elTextContent = elItem.querySelector('.fs-accordion__content__text')
    const elImage = elItem.querySelector('.fs-accordion__content__image')

    const height = elContent.scrollHeight
    await gsap.timeline({ defaults: { duration: 0.5, ease: 'sine.inOut' } })
      .fromTo([elTextContent, elImage], { opacity: 1 }, { opacity: 0 })
      .fromTo(elContent, { height }, { height: 0 }, '<')
      .set([elContent, elTextContent, elImage], { clearProps: true })
    elDetails.open = false
  }

  openItem(elItem) {
    const elDetails = elItem.querySelector('details')
    const elContent = elItem.querySelector('.fs-accordion__content')
    const elTextContent = elItem.querySelector('.fs-accordion__content__text')
    const elImage = elItem.querySelector('.fs-accordion__content__image')

    elDetails.open = true
    const height = elContent.scrollHeight

    gsap.timeline({ defaults: { duration: 0.5, ease: 'sine.inOut' } })
      .fromTo(elContent, { height: 0 }, { height, ease: 'sine.inOut' })
      .fromTo(elTextContent, { opacity: 0 }, { opacity: 1 }, '-=0.3')
      .fromTo(elImage, { opacity: 0 }, { opacity: 1 }, '-=0.4')
      .set([elContent, elTextContent, elImage], { clearProps: true })
  }
}

if (!customElements.get('fs-accordion')) {
  customElements.define('fs-accordion', FsAccordion)
}
